/**
 * OhMy Timeline-Autoplay:
 * Der Nav-Balken füllt sich als durchgehende Fortschrittslinie über alle Milestones.
 * Erreicht die Linie den Bullet des nächsten Schritts, wechselt der Slide.
 * Beim letzten Schritt läuft die Linie bis zum Balken-Ende und startet dann von vorn.
 * Sobald der Kunde selbst navigiert (Schritt antippen, Pfeile, Swipe), stoppt Autoplay
 * dauerhaft — die Linie zeigt dann statisch den aktuellen Schritt.
 * Pausiert außerhalb des Viewports; respektiert prefers-reduced-motion.
 */
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('effect-carousel[data-ohmy-autoplay]').forEach(function (carousel) {
    var root = carousel.closest('.shopify-section') || carousel.closest('[id^="shopify-section"]') || document;
    var bar = root.querySelector('.timeline__nav-bar');
    var navItems = Array.prototype.slice.call(root.querySelectorAll('.timeline__nav-item'));
    if (!bar || navItems.length < 2) return;

    var duration = (parseFloat(carousel.dataset.ohmyAutoplay) || 5) * 1000;
    var stopped = false;
    var visible = false;
    var rafId = null;
    var segmentStart = null;
    var autoClicking = false;
    var positions = [];

    // Position (0..1) des Bullet-Zentrums jedes Schritts auf dem Balken.
    // Der Bullet ist das ::before-Element am linken Rand des Nav-Items.
    function computePositions() {
      var barWidth = bar.offsetWidth || 1;
      var dotHalf = 6;
      try {
        var dotWidth = parseFloat(getComputedStyle(navItems[0], '::before').width);
        if (dotWidth > 0) dotHalf = dotWidth / 2;
      } catch (e) { /* Fallback 6px */ }
      positions = navItems.map(function (item) {
        return Math.min(1, (item.offsetLeft + dotHalf) / barWidth);
      });
    }

    function setProgress(p) {
      bar.style.setProperty('--ohmy-progress', String(Math.max(0, Math.min(1, p))));
    }

    function currentIndex() {
      for (var i = 0; i < navItems.length; i++) {
        if (navItems[i].getAttribute('aria-current') === 'true') return i;
      }
      return 0;
    }

    function advance() {
      var next = (currentIndex() + 1) % navItems.length;
      autoClicking = true;
      navItems[next].click();
      autoClicking = false;
    }

    function tick(ts) {
      if (stopped) return;
      if (!visible) { rafId = null; return; }
      if (segmentStart === null) segmentStart = ts;

      var i = currentIndex();
      var isLast = i === navItems.length - 1;
      var from = positions[i] || 0;
      var to = isLast ? 1 : (positions[i + 1] || 1);

      var t = (ts - segmentStart) / duration;
      if (t >= 1) {
        if (isLast) {
          // Ende erreicht: von vorn beginnen
          advance();
          segmentStart = ts;
          setProgress(positions[0] || 0);
        } else {
          // Bullet des nächsten Milestones erreicht -> Slide wechseln
          advance();
          segmentStart = ts;
          setProgress(to);
        }
      } else {
        setProgress(from + (to - from) * t);
      }
      rafId = requestAnimationFrame(tick);
    }

    function start() {
      if (stopped || rafId !== null) return;
      segmentStart = null;
      rafId = requestAnimationFrame(tick);
    }

    function syncToCurrent() {
      setProgress(positions[currentIndex()] || 0);
    }

    function stopForever() {
      if (stopped) return;
      stopped = true;
      if (rafId !== null) cancelAnimationFrame(rafId);
      rafId = null;
      // Linie bleibt als statische Fortschrittsanzeige am aktuellen Schritt
      setTimeout(syncToCurrent, 80);
    }

    computePositions();
    setProgress(positions[0] || 0);
    window.addEventListener('resize', function () {
      computePositions();
      if (stopped) syncToCurrent();
    }, { passive: true });

    // Bewusste Interaktion des Kunden -> Autoplay dauerhaft aus
    navItems.forEach(function (item) {
      item.addEventListener('click', function () {
        if (!autoClicking) stopForever();
      });
    });
    root.querySelectorAll('[is="prev-button"], [is="next-button"]').forEach(function (btn) {
      btn.addEventListener('click', stopForever);
    });
    carousel.addEventListener('pointerdown', stopForever); // Swipe/Tap auf die Slides

    // Nach manueller Navigation (auch Swipe) Linie am neuen Schritt ausrichten
    var mo = new MutationObserver(function () {
      if (stopped) syncToCurrent();
    });
    navItems.forEach(function (item) {
      mo.observe(item, { attributes: true, attributeFilter: ['aria-current'] });
    });

    if (reducedMotion) {
      // Kein Autoplay, aber Linie als statischer Fortschritt
      stopped = true;
      syncToCurrent();
      return;
    }

    // Nur laufen, wenn die Timeline sichtbar ist
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        visible = entry.isIntersecting;
        if (visible) start();
      });
    }, { threshold: 0.35 });
    observer.observe(carousel);
  });
})();
